import { render, staticRenderFns } from "./downloadApp.vue?vue&type=template&id=2f689b6b&"
import script from "./downloadApp.vue?vue&type=script&lang=ts&"
export * from "./downloadApp.vue?vue&type=script&lang=ts&"
import style0 from "./downloadApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports